import { Modal } from 'antd';
import { useIntl } from 'react-intl';
import { IDiscoveryCoupon, IUser } from 'src/shared/models';
import DiscoveryCoupon from './discoveryCoupon';
import { FC, useEffect, useRef, useState } from 'react';
import * as api from 'services/api';
import { IRootReducers } from 'src/reducers';
import { connect } from 'react-redux';
import { AnyAction, Dispatch, bindActionCreators } from 'redux';
import {
  setShowDiscoveryModal,
  setShowStaticPageDiscoveryModal,
  setUserCampaigns,
} from 'src/actions/appActions';
import { useRouter } from 'next/router';

interface OwnProps {
  discoveryCoupons?: IDiscoveryCoupon[];
  user: IUser;
  campaignId: string;
}

type Props = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps> &
  OwnProps;

const DiscoveryCouponsModal: FC<Props> = ({
  discoveryCoupons,
  user,
  campaignId,
  showModalFromRedux,
  setShowDiscoveryModal,
  setUserCampaigns,
  showStaticPageDiscoveryModal,
}): JSX.Element => {
  const { formatMessage } = useIntl();

  const router = useRouter();
  const { query } = router;
  const refTitle = useRef();

  const checkShowModal = (refTitle) => {
    refTitle.current?.scrollIntoView({ block: 'end', inline: 'nearest' });
    const campaign = query.campaign;
    if (campaign !== undefined && user && discoveryCoupons.length > 0) {
      return true;
    }
    return false;
  };

  useEffect(() => {
    const campaign = query.campaign;
    if (campaign !== undefined && user && discoveryCoupons.length > 0) {
      setShowModal(true);
      setShowDiscoveryModal(true);
    } else if (showModalFromRedux === false) {
      setShowModal(false);
    }
  }, [query, discoveryCoupons]);

  useEffect(() => {
    if (
      (showModalFromRedux === true && user) ||
      showStaticPageDiscoveryModal === true
    )
      setShowModal(true);
  }, [showModalFromRedux, discoveryCoupons]);

  const clickContinueWithoutCoupon = async () => {
    const joinCampaign = {
      campaignId: campaignId,
    };

    try {
      await api.joinCampaign(joinCampaign);
    } catch (err) {
      return;
    }
    const url = new URL(window.location.href);
    const queryParams = new URLSearchParams(url.search);
    queryParams.delete('campaign');
    let restantUrl = `${window.location.pathname}?${queryParams}`;
    if (restantUrl.charAt(restantUrl.length - 1) === '?') {
      restantUrl = restantUrl.slice(0, -1);
    }
    window.history.replaceState({}, '', restantUrl);
    setUserCampaigns();
    setShowModal(false);
    setShowDiscoveryModal(false);
    setShowStaticPageDiscoveryModal(false);
  };

  const [showModal, setShowModal] = useState(checkShowModal(refTitle));

  const POINTS_OVERWRITE = 'x2';

  return (
    <Modal
      visible={showModal && discoveryCoupons.length > 0}
      closable={false}
      centered
      footer={null}
      className="discovery-modal">
      <div ref={refTitle} className="discovery-modal-title-containter">
        <div className="discovery-modal-title-containter-two">
          <div className="discovery-modal-title">
            {formatMessage({
              id: 'consumables.modal.discovery.title',
            })}
          </div>
        </div>
      </div>
      <div>
        {discoveryCoupons.map((coupon, index: number) => (
          <div className="discovery-modal-coupons" key={index}>
            <DiscoveryCoupon
              consumableName={coupon.consumable.contents.name}
              consumableImg={coupon.consumable.contents.image}
              firstCoupon={index === 0}
              points={coupon.consumableScanPoints}
              campaignId={campaignId}
              consumableId={coupon.consumable.id}
              consumableProduct={coupon.consumable.consumableProduct}
              pointsOverwrite={POINTS_OVERWRITE}
            />
          </div>
        ))}
      </div>
      <div className="discovery-modal-continue-container">
        <div className="discovery-modal-continue-button">
          <a
            className="points-consumable-button-my-coupons"
            onClick={clickContinueWithoutCoupon}>
            {formatMessage({ id: 'consumable.modal.list.continue' })}
          </a>
        </div>
      </div>
    </Modal>
  );
};

const mapStateToProps = (state: IRootReducers) => {
  return {
    showModalFromRedux: state.app.showDiscoveryModal,
    user: state.auth.user,
    showStaticPageDiscoveryModal: state.app.showStaticPageDiscoveryModal,
  };
};

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) =>
  bindActionCreators({ setShowDiscoveryModal, setUserCampaigns }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DiscoveryCouponsModal);
